module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/coj_b-3-9acd9436e4f5a5c3d53c1cdde6b6e598.jpg";